import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import { Provider as ReduxProvider } from 'react-redux';
import { ApiToastNotifier } from '@/app/providers/ApiToastNotifier';
import { editorStore } from '@/app/store/store';
import { queryClient } from '@/app/providers/queryClient';
import { buildAntdTheme } from '@/shared/config/antdTheme';
/**
 * 安装全局服务端状态、客户端状态与主题 Provider。
 * 路由上下文由 AppRouter 内部的 RouterProvider 提供，这里不再包 Router。
 * @param props 应用子节点等 React 通用属性。
 * @returns 已安装全局 Provider 的应用节点。
 */
export function AppProviders(props) {
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(ReduxProvider, { store: editorStore, children: _jsx(ConfigProvider, { theme: buildAntdTheme(), children: _jsxs(AntdApp, { className: "app-antd-root", children: [_jsx(ApiToastNotifier, {}), props.children] }) }) }) }));
}
